module.exports = __webpack_public_path__ + "static/img/1.4bdf96a6.png";